import { Components, Theme } from '@mui/material/styles'

export const MuiListItem: Components<Theme>['MuiListItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '24px 16px',
      border: `1px solid ${theme.palette.secondary.dark}`,
      borderRadius: '16px',
      gap: '8px',
    }),
  },
}
